import { render, staticRenderFns } from "./GSTConfirmStagesForm.vue?vue&type=template&id=86d68b8a&scoped=true"
import script from "./GSTConfirmStagesForm.vue?vue&type=script&lang=js"
export * from "./GSTConfirmStagesForm.vue?vue&type=script&lang=js"
import style0 from "./GSTConfirmStagesForm.vue?vue&type=style&index=0&id=86d68b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d68b8a",
  null
  
)

export default component.exports